import AccordionList from 'component/AccordionList';
import AjaxForm from 'component/AjaxForm';
import AutoflameBrandsSlider from 'component/AutoflameBrandsSlider';
import AutoflameCalculator from 'component/AutoflameCalculator';
import RedirectForm from 'component/RedirectForm';
import EnrollmentForm from 'component/EnrollmentForm';
import NewsletterForm from 'component/NewsletterForm';
import CustomInput from 'component/CustomInput';
import CtaCarousel from 'component/cta-carousel';
import FixedQuote from 'component/FixedQuote';
import List from 'component/List';
import MainNav from 'component/MainNav';
import RepForm from 'component/RepForm';
import SubNav from 'component/Subnav';
import SlideShow from 'component/SlideShow';
import StickyKit from 'component/sticky-kit';
import SearchNav from 'component/SearchNav';
import VideoModal from 'component/VideoModal';
import PhotoSwipe from 'component/gallery-photoswipe';
import Calendar from 'component/Calendar';
import selectComponent from 'utilities/select-component';
import Share from 'component/share';
import ClassCard from 'component/ClassCard';
import Headroom from 'headroom.js';
import intlTelInput from 'intl-tel-input';
import 'vendor/magnific-popup/jquery.magnific-popup.min'; // eslint-disable-line no-unused-vars

const AUTO_MODULES = [PhotoSwipe];

export default function Site() {
	const init = () => {
		startDefault();
		startCustom();
		startTwoFactor();
	};

	const startDefault = function () {
		$.each(AUTO_MODULES, (key, Module) => {
			const instance = Module();
			instance.start();
		});
	};

	const startCustom = () => {
		selectComponent('accordion-content').each(
			(index, element) => new AccordionList(element)
		);

		selectComponent('ajax-form').each(
			(index, element) => new AjaxForm(element)
		);

		selectComponent('redirect-form').each(
			(index, element) => new RedirectForm(element)
		);

		selectComponent('enrollment-form').each(
			(index, element) => new EnrollmentForm(element)
		);

		selectComponent('blog-social').each(
			(index, element) => new StickyKit(element)
		);

		selectComponent('list').each((index, element) => new List(element));

		selectComponent('main-nav').each((index, element) => new MainNav(element));

		selectComponent('newsletter-form').each(
			(index, element) => new NewsletterForm(element)
		);

		selectComponent('rep-form').each((index, element) => new RepForm(element));

		selectComponent('search').each((index, element) => new SearchNav(element));

		selectComponent('select').each(
			(index, element) => new CustomInput(element)
		);

		selectComponent('share').each((index, element) => new Share(element));

		selectComponent('slide-show').each(
			(index, element) => new SlideShow(element)
		);

		selectComponent('sub-nav').each((index, element) => new SubNav(element));

		selectComponent('video-player').each(
			(index, element) => new VideoModal(element)
		);

		selectComponent('calendar').each(
			(index, element) => new Calendar(element, '/api/events')
		);

		selectComponent('cta-carousel').each(
			(index, element) => new CtaCarousel(element)
		);

		selectComponent('quote-cta').each(
			(index, element) => new FixedQuote(element)
		);

		selectComponent('autoflame-brands-slider').each(
			(index, element) => new AutoflameBrandsSlider(element)
		);

		selectComponent('autoflame-calculator').each(
			(index, element) => new AutoflameCalculator(element)
		);

		selectComponent('class-card').each(
			(index, element) => new ClassCard(element)
		);

		var myElement = document.querySelector('body');
		var headroom = new Headroom(myElement, {
			offset: 60,
			tolerance: {
				up: 40,
				down: 0,
			},
		});
		headroom.init();

		setTimeout(() => {
			$('iframe').each((index, element) => {
				const $iframe = $(element);
				if ($iframe.attr('src') && $iframe[0].contentDocument != null) {
					$iframe.before($iframe.clone());
					$iframe.remove();
				}
			});
		}, 1000);

		$('.responsive-video').each((index, element) => {
			setTimeout(() => {
				$(element)
					.addClass('-message')
					.append(
						'<p class="responsive-video__error-message">There was a problem loading this video.<br>Please refresh your browser to try again.</p>'
					);
			}, 2000);
		});

		$('form').each(function () {
			var form_name = $(this).attr('data-form-name');

			if (window.dataLayer && typeof form_name !== 'undefined') {
				window.dataLayer.push({ form_name: form_name });
			}
		});
	};

	const startTwoFactor = () => {
		const input = document.querySelector('.phone');

		intlTelInput(input, {
			strictMode: true,
			autoInsertDialCode: true,
			nationalMode: false,
			separateDialCode: true,
			initialCountry: 'us',
			utilsScript: '/assets/js/vendor/intl-tel-input-utils.js',
			hiddenInput: () => ({ phone: 'full-phone' }),
		});

		$('#email-two-factor-modal #close-window').on('click', function () {
			location.reload();
		});

		$('#email-two-factor-modal #send-request-again').on('click', function () {
			var submission_id = $('#email-two-factor-modal #submission_id').val();
			var session_id = $('#email-two-factor-modal #session_id').val();

			$.ajax({
				url: '/api/resend-email-two-factor',
				type: 'POST',
				data: {
					id: submission_id,
					session_id: session_id,
				},
			}).always(function () {
				$('#email-two-factor-modal #send-request-again').text('Email resent!');
			});
		});

		$('#email-two-factor-auth-method-form').on('submit', function (e) {
			e.preventDefault();
			$('#email-two-factor-auth-method-form input').attr('disabled', true);

			var submission_id = $('#email-two-factor-modal #submission_id').val();
			var session_id = $('#email-two-factor-modal #session_id').val();
			var method = $(
				'#email-two-factor-auth-method-form input[name="method"]:checked'
			).val();
			var phone = $(
				'#email-two-factor-auth-method-form [name=full-phone]'
			).val();
			// Set the auth method and go ahead and send it
			$.ajax({
				url: '/api/email-two-factor-method',
				type: 'POST',
				data: {
					id: submission_id,
					session_id: session_id,
					method: method,
					phone: phone,
				},
				dataType: 'text json',
			}).always(function (resp) {
				var data = resp.responseJSON === undefined ? resp : resp.responseJSON;
				var message = data.message;
				var created_at = data.created_at;
				var valid_for = data.valid_for;
				var recipient = data.recipient;

				if (data.success == true) {
					$('#email-two-factor-form #phone_number').text(recipient);
					$('#email-two-factor-form #email_address').text(recipient);
					$('#email-two-factor-form #created_at').text(created_at);
					$('#email-two-factor-form #valid_for').text(valid_for);

					if (method == 'email_method') {
						$('#email-two-factor-form #phone-intro').remove();
					} else {
						$('#email-two-factor-form #email-intro').remove();
					}

					$('#email-two-factor-auth-method-form').remove();
					$('#email-two-factor-form').removeClass('hide-form');
				} else {
					$('#email-two-factor-auth-method-form input').attr('disabled', false);
					$('#email-two-factor-auth-method-form .intro').html(message);
				}
			});
		});

		$('#email-two-factor-form').on('submit', function (e) {
			e.preventDefault();

			var submission_id = $('#email-two-factor-modal #submission_id').val();
			var session_id = $('#email-two-factor-modal #session_id').val();
			var code = $('#email-two-factor-modal #pincode').val();

			$('#email-two-factor-modal form input').attr('disabled', true);

			$.ajax({
				url: '/api/email-two-factor',
				type: 'POST',
				data: {
					id: submission_id,
					session_id: session_id,
					code: code,
				},
				dataType: 'text json',
			}).always(function (resp) {
				var data = resp.responseJSON === undefined ? resp : resp.responseJSON;
				var message = data.message;

				if (data.success == true) {
					var headline = data.headline;

					$('#email-two-factor-modal > h2').html(headline);
					$('#email-two-factor-modal .intro').html(message);
					$('#email-two-factor-modal #send-request-again').remove();
					$('#email-two-factor-modal form input').remove();
					$('#close-window').removeClass('hide-button');
				} else {
					var error_type = data.error;

					$('#email-two-factor-modal form input').attr('disabled', false);

					if (error_type == 'code_mismatch') {
						var attempts_left = data.attempts_left;
						var message_copy =
							'<span class="error">The code you entred is incorrect.</span> Try again.<br />You have ' +
							attempts_left +
							' attempts left';

						$('#email-two-factor-modal .intro').html(message_copy);
					}

					if (error_type == 'generic') {
						$('#email-two-factor-modal .intro').text(message);
					}

					if (error_type == 'expired' || error_type == 'max_attempts') {
						$('#email-two-factor-modal .intro').html(message);
						$('#email-two-factor-modal #send-request-again').remove();
						$('#email-two-factor-modal form input').remove();
						$('#close-window').removeClass('hide-button');
					}
				}
			});
		});
	};

	return {
		init,
	};
}
